import { Component, Host, h, Prop, Element } from '@stencil/core';

@Component({
    tag: 'sew-menu',
    styleUrl: 'sew-menu.scss',
    shadow: true,
})
export class SewMenu {
    @Element() el: HTMLSewMenuElement;

    @Prop({ reflect: true }) open: boolean;
    @Prop() maxHeightInPixel: string;

    componentDidRender(): void {
        if (this.open) {
            const computedHeight = window.getComputedStyle(this.el).height;

            this.el.style.setProperty('--list-max-height', this.maxHeightInPixel || computedHeight);
            this.el.classList.add('open-animation');
        } else {
            this.el.classList.remove('open-animation');
        }
    }

    render() {
        return (
            <Host>
                <slot></slot>
            </Host>
        );
    }
}
